import templates from '../templates';

const confirmation = (() => {
    let $template = null;
    let $dialog = null;
    let _confirmed = false;
    let _onConfirm = null;
    let _onCancel = null;

    const _reset = () => {
        if ($dialog) {
            $dialog.destroy();
        }

        if ($template) {
            $template.remove();
        }

        $dialog = null;
        $template = null;
    };

    const _onClose = () => {
        const callback = _confirmed ? _onConfirm : _onCancel;
        _reset();

        if (typeof callback === 'function') {
            callback();
        }
    };

    const _close = (confirmed) => {
        _confirmed = confirmed;
        $dialog.close();
    };

    return (options, onConfirm, onCancel) => {
        if ($dialog) {
            return $dialog;
        }

        _confirmed = false;
        _onConfirm = onConfirm;
        _onCancel = onCancel;

        $template = $(templates('dialog-confirmation', {
            icon: options.icon || 'exclamation-triangle',
            title: options.title,
            subtitle: options.subtitle,
            message: options.message
        }));

        $template.find('button').kendoButton();
        $template.on('submit', (e) => {
            e.preventDefault();
            _close(true);
        });
        $template.on('reset', (e) => {
            e.preventDefault();
            _close(false);
        });

        $dialog = $template.kendoWindow({
            actions: ['close'],
            width: '460px',
            resizable: false,
            draggable: true,
            modal: true,
            visible: false,
            appendTo: 'body',
            close: _onClose
        }).data('kendoWindow');

        $dialog.wrapper.addClass('dialog-confirmation-window');

        return $dialog.center().open();
    };
})();

export default confirmation;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/confirmation.js